import { useState } from 'react';

type FlagProps = {
    code: string;
};

const AVAILABLE_FLAGS = [
    'af',
    'eg',
    'ax',
    'al',
    'dz',
    'as',
    'vi',
    'ad',
    'ao',
    'ai',
    'aq',
    'ag',
    'gq',
    'ar',
    'am',
    'aw',
    'az',
    'et',
    'au',
    'bs',
    'bh',
    'bd',
    'bb',
    'by',
    'be',
    'bz',
    'bj',
    'bm',
    'bt',
    'bo',
    'bq',
    'ba',
    'bw',
    'bv',
    'br',
    'vg',
    'io',
    'bn',
    'bg',
    'bf',
    'bi',
    'cl',
    'cn',
    'ck',
    'cr',
    'ci',
    'cw',
    'dk',
    'de',
    'dm',
    'do',
    'dj',
    'ec',
    'sv',
    'er',
    'ee',
    'fk',
    'fo',
    'fj',
    'fi',
    'fr',
    'gf',
    'pf',
    'tf',
    'ga',
    'gm',
    'ge',
    'gh',
    'gi',
    'gd',
    'gr',
    'gl',
    'gp',
    'gu',
    'gt',
    'gg',
    'gn',
    'gw',
    'gy',
    'ht',
    'hm',
    'hn',
    'hk',
    'in',
    'id',
    'im',
    'iq',
    'ir',
    'ie',
    'is',
    'il',
    'it',
    'jm',
    'jp',
    'ye',
    'je',
    'jo',
    'ky',
    'kh',
    'cm',
    'ca',
    'cv',
    'kz',
    'qa',
    'ke',
    'kg',
    'ki',
    'cc',
    'co',
    'km',
    'cd',
    'cg',
    'kp',
    'kr',
    'hr',
    'cu',
    'kw',
    'la',
    'ls',
    'lv',
    'lb',
    'lr',
    'ly',
    'li',
    'lt',
    'lu',
    'mo',
    'mg',
    'mw',
    'my',
    'mv',
    'ml',
    'mt',
    'ma',
    'mh',
    'mq',
    'mr',
    'mu',
    'yt',
    'mx',
    'fm',
    'md',
    'mc',
    'mn',
    'me',
    'ms',
    'mz',
    'mm',
    'na',
    'nr',
    'np',
    'nc',
    'nz',
    'ni',
    'nl',
    'ne',
    'ng',
    'nu',
    'mp',
    'mk',
    'nf',
    'no',
    'om',
    'at',
    'tl',
    'pk',
    'ps',
    'pw',
    'pa',
    'pg',
    'py',
    'pe',
    'ph',
    'pn',
    'pl',
    'pt',
    'pr',
    're',
    'rw',
    'ro',
    'ru',
    'sb',
    'bl',
    'mf',
    'zm',
    'ws',
    'sm',
    'st',
    'sa',
    'se',
    'ch',
    'sn',
    'rs',
    'sc',
    'sl',
    'zw',
    'sg',
    'sx',
    'sk',
    'si',
    'so',
    'es',
    'lk',
    'sh',
    'kn',
    'lc',
    'pm',
    'vc',
    'za',
    'sd',
    'gs',
    'ss',
    'sr',
    'sj',
    'sz',
    'sy',
    'tj',
    'tw',
    'tz',
    'th',
    'tg',
    'tk',
    'to',
    'tt',
    'td',
    'cz',
    'tn',
    'tr',
    'tm',
    'tc',
    'tv',
    'ug',
    'ua',
    'hu',
    'um',
    'uy',
    'uz',
    'vu',
    'va',
    've',
    'ae',
    'us',
    'gb',
    'vn',
    'wf',
    'cx',
    'eh',
    'cf',
    'cy'
];

const Flag = ({ code }: FlagProps) => {
    const [hasError, setHasError] = useState(false);

    if (!AVAILABLE_FLAGS.includes(code) || hasError) {
        return <span className='flag' />;
    }

    return (
        <span className='flag'>
            <img
                src={`${process.env.PUBLIC_URL}/assets/flags/${code}.svg`}
                alt={code}
                onError={() => setHasError(true)}
            />
        </span>
    );
};

export default Flag;
